import * as typedrequest from '@api.global/typedrequest';
import * as typedrequestInterfaces from '@api.global/typedrequest-interfaces';
import * as typedsocket from '@api.global/typedsocket';

import * as deesCatalog from '@design.estate/dees-catalog';
import * as deesElement from '@design.estate/dees-element';

import * as simpleWebAuthnBrowser from '@simplewebauthn/browser';

// The account-mutation rule on its own: authswitch's `./mutation` entry point is a leaf that
// imports nothing, so the browser applies the rule authswitch owns instead of restating it,
// while the package's root export stays Node-only.
import * as authswitchMutation from '@modelprofile.com/authswitch/mutation';

// Bundled statically: the CSP allows no CDN scripts, so the catalog's lib
// loader is fed these modules instead of fetching them at runtime.
import { Terminal as XtermTerminal } from 'xterm';
import { FitAddon as XtermFitAddon } from 'xterm-addon-fit';
import highlightJs from 'highlight.js';
import { DevToolsFrontend, LiveBrowserVideoRenderer } from '@push.rocks/smartbrowser/web';
import type {
  ILiveBrowserVideoClient,
  ILiveBrowserVideoRendererStatistics,
  ILiveVideoAcceleration,
  TLiveBrowserEventListener,
  TDevToolsPanel,
} from '@push.rocks/smartbrowser/web';

export {
  authswitchMutation,
  deesCatalog,
  deesElement,
  simpleWebAuthnBrowser,
  typedrequest,
  typedrequestInterfaces,
  typedsocket,
  XtermTerminal,
  XtermFitAddon,
  highlightJs,
  LiveBrowserVideoRenderer,
  DevToolsFrontend,
};
export type {
  ILiveBrowserVideoClient,
  ILiveBrowserVideoRendererStatistics,
  ILiveVideoAcceleration,
  TLiveBrowserEventListener,
  TDevToolsPanel,
};
